import { RefObject, createContext, useContext, useRef } from "react";

import {
  Accordion as SemanticAccordion,
  AccordionProps as SemanticAccordionProps,
  AccordionTitleProps as SemanticAccordionTitleProps,
} from "semantic-ui-react";

const AccordionContext = createContext<{
  accordionRef: RefObject<HTMLDivElement | null>;
}>({ accordionRef: { current: null } });

const Accordion = (props: SemanticAccordionProps) => {
  const accordionRef = useRef<HTMLDivElement>(null);

  return (
    <AccordionContext.Provider value={{ accordionRef }}>
      <SemanticAccordion {...props} ref={accordionRef} />
    </AccordionContext.Provider>
  );
};

const AccordionTitle = (props: SemanticAccordionTitleProps) => {
  const { accordionRef } = useContext(AccordionContext);
  return (
    <SemanticAccordion.Title
      {...props}
      onClick={(e, data) => {
        props.onClick?.(e, data);
        if (!data.active) {
          setTimeout(() => {
            if (accordionRef.current) {
              accordionRef.current.scrollIntoView({ behavior: "smooth" });
            }
          }, 50);
        }
      }}
    />
  );
};

Accordion.Title = AccordionTitle;
Accordion.Content = SemanticAccordion.Content;
Accordion.Panel = SemanticAccordion.Panel;

export { Accordion };
